import { useEffect, useRef, useState } from 'react';

export const useOfflineRetry = (loading: boolean, onRetry: () => void) => {
  const [isOffline, setIsOffline] = useState(false);
  const pendingRetryRef = useRef(false);
  const onRetryRef = useRef(onRetry);
  onRetryRef.current = onRetry;

  useEffect(() => {
    setIsOffline(!navigator.onLine);
  }, []);

  useEffect(() => {
    const handleOnline = () => {
      setIsOffline(false);
      pendingRetryRef.current = true;
    };
    const handleOffline = () => setIsOffline(true);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  useEffect(() => {
    if (!pendingRetryRef.current || loading || !navigator.onLine) return;

    pendingRetryRef.current = false;
    onRetryRef.current();
  }, [isOffline, loading]);

  return isOffline;
};
